/**
 * sync a variable with the router.
 */
export const syncRoute = (
    variable: MaybeRefOrGetter<Readonly<any>>,
    param: MaybeRefOrGetter<Readonly<string>>,
    additionalQueryParams: MaybeRefOrGetter<Readonly<object>> = {}
) => {
    const router = useRouter();
    const route = useRoute();

    watch (() => toValue(variable), (newValue, oldValue) => {
        const oldIsEmpty = !oldValue || (Array.isArray(oldValue) && oldValue.length === 0);
        const newIsEmpty = !newValue || (Array.isArray(newValue) && newValue.length === 0);

        if (oldIsEmpty && newIsEmpty) {
            return;
        }

        router.push({
            query: {
                ...route?.query ?? {},
                [toValue(param)]: toValue(variable),//.map(({ value }) => value) || null,
                ...additionalQueryParams
            }
        });
    });
};
